import React from "react";
import { Col, Radio, Row, Spin } from "antd";
import { RadioChangeEvent } from "antd/lib/radio/interface";
import fieldStyle from "./index.module.scss";
import OverflowWrapper from "components/OverflowWrapper";
import { ExamPaperListItem } from "service/exam";

interface FieldTypesProps {
    value: string; //当前选中paperId
    examPaperList: ExamPaperListItem[]; //试卷列表
    onChangeCheckItem: (val: string) => void; //修改选择项
    PaperListloading: boolean; //加载状态
}

export default function FieldTypes({
    examPaperList,
    value,
    onChangeCheckItem,
    PaperListloading
}: FieldTypesProps) {
    function onChange(e: RadioChangeEvent) {
        onChangeCheckItem(e.target.value);
    }

    return (
        <Spin spinning={PaperListloading}>
            <Row>
                <Col span={24}>
                    <OverflowWrapper width={780} depth={2}>
                        <Radio.Group value={value} onChange={onChange}>
                            {examPaperList.map(item => (
                                <Radio.Button
                                    className={fieldStyle.tab}
                                    key={item.paperId}
                                    value={item.paperId}>
                                    <span title={item.paperName}>
                                        {item.paperName}
                                    </span>
                                </Radio.Button>
                            ))}
                        </Radio.Group>
                    </OverflowWrapper>
                </Col>
            </Row>
        </Spin>
    );
}
